/* src/app/front-layout/test/test.component.css */
.mtc-title {
  font-weight: 800;
  text-align: center;
  margin: 8px 0 24px;
  color: #0f172a;
  font-size: 32px;
}
.mock-calendar {
  --toolbar: #f6c20f;
  --toolbar-dark: #e0ad05;
  --online: #fb923c;
  --ff: #22c55e;
  --book: #0a84ae;
  --book-dark: #0a6e90;
  --card-border: #dbeafe;
  --card-hover: #1d4ed8;
}
.mock-calendar .toolbar {
  background: var(--toolbar);
  padding: 20px;
  border-radius: 12px;
  margin: 0 8px 24px;
}
.mock-calendar .toolbar .toolbar-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}
.mock-calendar .toolbar .toolbar-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}
.mock-calendar .toolbar .toolbar-item label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .02em;
  color: #333;
  margin: 0;
  text-align: center;
}
.mock-calendar .toolbar .dropdown-like {
  position: relative;
}
.mock-calendar .toolbar .dropdown-like .form-select,
.mock-calendar .toolbar .dropdown-like select {
  appearance: none;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 8px 28px 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  cursor: pointer;
}
.mock-calendar .toolbar .dropdown-like .chev {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  pointer-events: none;
  color: #666;
}
.mock-calendar .list-body .session-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: auto 1fr auto auto auto;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;
}
.mock-calendar .list-body .session-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.mock-calendar .list-body .session-card .date-chip {
  background: #0a84ae;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
  min-width: 100px;
  text-align: center;
}
.mock-calendar .list-body .session-card .date-chip.range {
  background: #f59e0b;
}
.mock-calendar .list-body .session-card .date-chip span {
  color: inherit;
  background: none;
  padding: 0;
  border-radius: 0;
  font-weight: inherit;
}
.mock-calendar .list-body .session-card .session-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mock-calendar .list-body .session-card .session-title {
  font-weight: 700;
  color: #1e40af;
  text-decoration: none;
  font-size: 16px;
}
.mock-calendar .list-body .session-card .session-subtitle {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  text-decoration: none;
}
.mock-calendar .list-body .session-card .session-pattern {
  font-size: 13px;
  color: #6b7280;
  text-decoration: none;
}
.mock-calendar .list-body .session-card .badges {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.mock-calendar .list-body .session-card .badges .badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  color: #fff;
}
.mock-calendar .list-body .session-card .badges .badge-online {
  background: var(--online);
}
.mock-calendar .list-body .session-card .badges .badge-ff {
  background: var(--ff);
}
.mock-calendar .list-body .session-card .badges .location-badge {
  background: #fbbf24;
  color: #92400e;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.mock-calendar .list-body .session-card .badges .location-badge img {
  width: 14px;
  height: 14px;
}
.mock-calendar .list-body .session-card .badges .location-badge .truncate {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mock-calendar .list-body .session-card .price {
  font-weight: 800;
  font-size: 16px;
  color: #0f172a;
  text-align: right;
  min-width: 80px;
}
.mock-calendar .list-body .session-card .action .btn-book,
.mock-calendar .btn-book {
  background: var(--book);
  color: #fff;
  border-radius: 20px;
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: background 0.2s ease;
  min-width: 80px;
  border: none;
  cursor: pointer;
}
.mock-calendar .btn-book:hover {
  background: var(--book-dark);
}
.mock-calendar .btn-load {
  background: var(--toolbar-dark);
  color: #111827;
  border-radius: 20px;
  padding: 12px 24px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.mock-calendar .btn-load:hover {
  background: #d69e00;
}
.hidden {
  display: none;
}
@media (max-width: 991.98px) {
  .mock-calendar .toolbar .toolbar-row {
    flex-direction: column;
    gap: 12px;
  }
  .mock-calendar .toolbar .toolbar-item {
    min-width: 200px;
  }
  .mock-calendar .list-body .session-card {
    grid-template-columns: 1fr;
    gap: 12px;
    text-align: center;
  }
  .mock-calendar .list-body .session-card .session-info {
    align-items: center;
  }
  .mock-calendar .list-body .session-card .badges {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .mock-calendar .toolbar .toolbar-row {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=test.component.css.map */
